import { ContentScope } from './contentScope';
import { requestJson } from './http';
const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';
export interface DonorGiftOffer {
  product_key: string; story_id: string; title: string; description: string;
  content_scope?: ContentScope | null;
  amount_minor: number; currency: string;
}
export interface DonorGiftOrder {
  id: string; product_key: string; title: string; status: string; checkout_url?: string | null;
}
export interface DonorGiftsView {
  offers: DonorGiftOffer[]; orders: DonorGiftOrder[]; checkout_enabled: boolean;
}
export const fetchDonorGifts = (): Promise<DonorGiftsView> =>
  requestJson(`${API_BASE_URL}/donor-session/gifts`, { credentials: 'include' });
export const fetchDonorGiftOrder = (id: string): Promise<DonorGiftOrder> =>
  requestJson(`${API_BASE_URL}/donor-session/gifts/orders/${encodeURIComponent(id)}`, { credentials: 'include' });
export const startDonorGiftCheckout = (productKey: string, idempotencyKey: string): Promise<{
  order_id: string; checkout_url?: string | null; status: string;
}> => requestJson(`${API_BASE_URL}/donor-session/gifts/checkout`, {
  method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ product_key: productKey, idempotency_key: idempotencyKey }),
});
/** Best-effort display measurement; no purchaser or recipient identity is supplied by the browser. */
export async function recordDonorGiftOfferViewed(): Promise<void> {
  try {
    await fetch(`${API_BASE_URL}/donor-session/gifts/viewed`, { method: 'POST', credentials: 'include' });
  } catch { /* Analytics must never interrupt a gift. */ }
}
